// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"718e8173","453":"db5ab6b3","455":"fa71bef6","977":"e14d4ee5"}[chunkId] + ".chunk.js";
};